import React from 'react';
import { Process, PMNode, NODE_CATALOG_BY_SUBTYPE, resolveNodeSubtype } from '../../types';
import type { Segment } from '../../migrations/legacyEdge';
import { impactScore, impactColor, impactLabel } from '../../utils/impact';
import { buildEdgeMap, resolveProcessEdges } from '../../utils/processEdges';

interface ImpactLayerProps {
  processes: Process[];
  edges: Segment[];
  nodes:     Record<string, PMNode>;
}

const ImpactLayer: React.FC<ImpactLayerProps> = ({ processes, edges, nodes }) => {
  const nodeScores: Record<string, number> = {};
  const edgeMap = buildEdgeMap(edges);
  processes.forEach(proc => {
    if (proc.visible === false) return;
    resolveProcessEdges(proc, edgeMap).forEach(seg => {
      const s = impactScore(seg);
      [seg.from, seg.to].forEach(id => {
        nodeScores[id] = Math.max(nodeScores[id] ?? 0, s);
      });
    });
  });

  return (
    <g id="layer-impact" pointerEvents="none">
      {Object.entries(nodeScores).map(([id, score]) => {
        const color = impactColor(score);
        const label = impactLabel(score);
        if (!color || !label || !nodes[id]) return null;
        const { x: cx, y: cy, type, subtype } = nodes[id];
        const resolvedSubtype = resolveNodeSubtype(type, subtype);
        const isDia = false; //NODE_CATALOG_BY_SUBTYPE[resolvedSubtype].style.shape === 'diamond';
        const bx    = cx + (isDia ? 38 : 9);
        const by    = cy - (isDia ? 24 : 9);
        return (
          <g key={id}>
            {isDia
              ? <rect x={cx - 38} y={cy - 24} width={76} height={48} rx={12}
                  fill="none" stroke={color} strokeWidth={3} opacity={0.5} />
              : <circle cx={cx} cy={cy} r={14}
                  fill="none" stroke={color} strokeWidth={3} opacity={0.45} />
            }
            <rect x={bx - 10} y={by - 9} width={20} height={13} rx={6} fill={color} />
            <text x={bx} y={by} textAnchor="middle" dominantBaseline="central"
              fontSize={8} fill="white" fontFamily="'DM Mono',monospace" fontWeight={600}>
              {label}
            </text>
          </g>
        );
      })}
    </g>
  );
};

export default ImpactLayer;
